import HmEventRegistry from './../model/HmEventRegistry';
import heyIcon from './../images/icons/heypractest_icon.png';

const FreshChatWidget = function(){
	
	let USER_STORE = null;


	let IS_USER_PARAMS_ADDED = false;

	return{
		init:function(){
			try{
				var urlPathName = window.location.pathname;
				if(urlPathName.indexOf("openlessonview/") > -1 || urlPathName.indexOf("lessonview/") > -1){
					return;  
				}

				if(!window.fcWidget){
					return;
				}


				window.fcWidget.init({
					token: "888bef39-c0da-4bda-8f07-725d8cf794b1", 
					host: "https://wchat.freshchat.com" ,
					config: {
						disableEvents: true,
						cssNames: {
							widget: 'fc_frame',
							open: 'fc_open',
							expanded: 'fc_expanded'
						},
						showFAQOnOpen: true,
						hideFAQ: true,
						agent: {
							hideName: false,
							hidePic: false,
							hideBio: false,
						},
						headerProperty: {
			      //If you have multiple sites you can use the appName and appLogo to overwrite the values.
			      appName: '',
			      hideChatButton: true,
			      appLogo: heyIcon,
			      backgroundColor: '#f76d7e',
			      foregroundColor: '#fff',
			      backgroundImage: 'https://wchat.freshchat.com/assets/images/texture_background_1-bdc7191884a15871ed640bcb0635e7e7.png'
			  },
			  content: {
			  	placeholders: {
			  		search_field: 'Search',
			  		reply_field: 'Reply',
			  		csat_reply: 'Add your comments here'
			  	},
			  	actions: {
			  		csat_yes: 'Yes',
			  		csat_no: 'No',
			  		push_notify_yes: 'Yes',
			  		push_notify_no: 'No',
			  		tab_faq: 'Solutions',
			  		tab_chat: 'Chat',
			  		csat_submit: 'Submit'
			  	},
			  	headers: {
			  		chat: 'Chat with Us',
			  		chat_help: 'Reach out to us if you have any questions',
			  		faq: 'Solution Articles',
			  		faq_help: 'Browse our articles',
			  		faq_not_available: 'No Articles Found',
			  		faq_search_not_available: 'No articles were found for {{query}}',
			  		faq_useful: 'Was this article helpful?',
			  		faq_thankyou: 'Thank you for your feedback',
			  		faq_message_us: 'Message Us',
			  		push_notification: 'Don\'t miss out on any replies! Allow push notifications?',
			  		csat_question: 'Did we address your concerns??',
			  		csat_yes_question: 'How would you rate this interaction?',
			  		csat_no_question: 'How could we have helped better?',
			  		csat_thankyou: 'Thanks for the response',
			  		csat_rate_here: 'Submit your rating here',
			  		channel_response: {
			  			offline: 'We are currently away. Please leave us a message',
			  			online: {
			  				minutes: {
			  					one: "Currently replying in {!time!} minutes ",
			  					more: "Typically replies in {!time!} minutes"
			  				},
			  				hours: {
			  					one: "Currently replying in under an hour",
			  					more: "Typically replies in {!time!} hours",
			  				}
			  			}
			  		}
			  	}
			  }
			}
		});

				window.fcWidget.on("widget:loaded",function() {
					document.getElementById('custom_fc_button').style.visibility = 'visible';       	

					window.fcWidget.on("widget:closed", function() {
						document.getElementById('fc_frame').style.visibility = 'hidden';
						document.getElementById('open_fc_widget').style.visibility = 'visible';
					});
					window.fcWidget.on("widget:opened", function(resp) {
						document.getElementById('open_fc_widget').style.visibility = 'hidden';
					});
				});
			}catch(e){
				console.error(e);
			}


		},
		setUser:function(userStore){
			try{

				if(IS_USER_PARAMS_ADDED){
					return;
				}	

				if(!window.fcWidget || !window.fcWidget.user || !window.fcWidget.user.setProperties){
					return;
				}

				if(userStore && userStore.getUserId() && userStore.getUserId().length > 0){
					USER_STORE = userStore;
				}

				if(USER_STORE && USER_STORE.getUserId() && USER_STORE.getUserId().length > 0){
					IS_USER_PARAMS_ADDED = true;


					window.fcWidget.user.setProperties({
						firstName: USER_STORE.getUserName() || "",
						lastName: "",
						externalId: USER_STORE.getLoginId() || "",
						email: USER_STORE.getEmail() || "",
						phone: USER_STORE.getMobile() || "",
						"status": "Active"				
					});

				}
			}catch(e){
				IS_USER_PARAMS_ADDED = false;
			}
		},
		clearUser:function(){
			try{
				IS_USER_PARAMS_ADDED = false;
				if(!window.fcWidget){
					return;
				}

				window.fcWidget.clear();
			}catch(e){
				IS_USER_PARAMS_ADDED = false;
			}
		}
	};
}();

export default FreshChatWidget;

HmEventRegistry.registerEvent("INIT_FRESHCHAT",function(){
	FreshChatWidget.init();
});

HmEventRegistry.registerEvent("ADD_USER_FRESHCHAT",function(userStore){
	FreshChatWidget.setUser(userStore);
});

HmEventRegistry.registerEvent("CLEAR_USER_FRESHCHAT",function(){
	FreshChatWidget.clearUser();
});


// WEBPACK FOOTER //
// ./src/vendors/FreshChatWidget.js